import { Box, Typography } from "@mui/material";

export default function BigImage({ src, alt, maxHeight }) {
  return src ? (
    <img
      src={src}
      alt={alt ?? ""}
      style={{ maxHeight: maxHeight ?? 600, margin: "0 auto", display: "block", width: "100%", objectFit: "contain" }}
    />
  ) : (
    <Box
      sx={{
        width: 800,
        height: maxHeight ?? 600,
        bgcolor: "#FAFAFA",
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="body2" color="textSecondary">
        Image not available
      </Typography>
    </Box>
  );
}
